<template>
    <div class="engineering">
        <el-container>
            <el-header>
                <el-form :inline="true" :model="dataForm" label-width="100px">
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="项目部：">
                                <el-select v-model="dataForm.deptId" placeholder="请选择项目部" @change="getProjectList">
                                    <el-option :label="deptItem.applyDeptName" :value="deptItem.applyDeptId" v-for="(deptItem,deptIndex) in deptList" :key="'deptItem'+deptIndex"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="项目名称：">
                                <el-select v-model="dataForm.projectId" placeholder="请选择项目名称">
                                    <el-option :label="projectItem.name" :value="projectItem.id" v-for="(projectItem,projectIndex) in projectList" :key="'projectItem'+projectIndex"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" class="btnRight">
                            <el-form-item class="btnList">
                                <el-button type="primary" @click="query()">查 询</el-button>
                                <el-button type="info" @click="reset()">重 置</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <el-row>
                    <el-col :span="24">
                        <div class="operatePanel">
                            <el-button
                                    v-if="btnAuthorize.export.btnEnable"
                                    type="primary"
                                    icon="el-icon-download"
                                    @click="exportBtn()"
                            >导出</el-button>
                        </div>
                    </el-col>
                </el-row>
            </el-header>
            <el-main ref="main">
                <el-table
                        ref="dataTable"
                        :data="engineerList"
                        :span-method="spanArrayMethod"
                        highlight-current-row
                        size="mini"
                        height="100%"
                        border
                >
                    <el-table-column label="细目信息（总包）"
                                     :show-overflow-tooltip="true">
                        <el-table-column prop="subCategoryName" label="细目名称"
                                         :show-overflow-tooltip="true"></el-table-column>
                        <el-table-column prop="subCategoryNo" label="细目号"
                                         :show-overflow-tooltip="true"></el-table-column>
                    </el-table-column>
                    <el-table-column prop="projectName" label="清单（总包）"
                                     :show-overflow-tooltip="true">
                        <el-table-column prop="deptName" label="价格"
                                         :show-overflow-tooltip="true">
                            <el-table-column prop="unit" label="单位"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column label="单价" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <el-input size="mini" v-model="scope.row.unitPrice"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="是否正式单价" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <el-checkbox v-model="scope.row.unitPriceTypeBool" :checked="scope.row.unitPriceTypeBool">正式单价</el-checkbox>
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column prop="deptName" label="合同"
                                         :show-overflow-tooltip="true">
                            <el-table-column label="合同数量" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <el-input size="mini" v-model="scope.row.contractCount"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="contractSumPrice" label="合同合价"
                                             :show-overflow-tooltip="true"></el-table-column>
                        </el-table-column>
                        <el-table-column prop="deptName" label="核实"
                                         :show-overflow-tooltip="true">
                            <el-table-column label="核实数量" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <el-input size="mini" v-model="scope.row.checkCount"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="checkSumPrice" label="核实合价"
                                             :show-overflow-tooltip="true"></el-table-column>
                        </el-table-column>
                        <el-table-column prop="deptName" label="计划数量"
                                         :show-overflow-tooltip="true">
                            <el-table-column label="数量" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <el-input size="mini" v-model="scope.row.expectCount"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="expectSumPrice" label="合价"
                                             :show-overflow-tooltip="true"></el-table-column>
                        </el-table-column>
                        <el-table-column prop="deptName" label="实际完成数量"
                                         :show-overflow-tooltip="true">
                            <el-table-column label="数量" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <el-input size="mini" v-model="scope.row.actFinishCount"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="actFinishSumPrice" label="合价"
                                             :show-overflow-tooltip="true"></el-table-column>
                        </el-table-column>
                        <el-table-column prop="deptName" label="计划完成数量"
                                         :show-overflow-tooltip="true">
                            <el-table-column label="数量" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <el-input size="mini" v-model="scope.row.expectFinishCount"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="expectFinishSumPrice" label="合价"
                                             :show-overflow-tooltip="true"></el-table-column>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="预计成本"
                                     :show-overflow-tooltip="true">
                        <el-table-column label="劳务"
                                         :show-overflow-tooltip="true">
                            <el-table-column prop="laborItem_subCategoryName" label="细目名称" width="150px"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="laborItem_subCategoryNo" label="细目号"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="laborItem_unit" label="单位"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column label="单价" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.laborItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.laborItem_unitPrice"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="是否正式单价" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.laborItem_subCategoryName">
                                    <el-checkbox v-model="scope.row.laborItem_unitPriceTypeBool"
                                                 :checked="scope.row.laborItem_unitPriceTypeBool"
                                                 >正式单价</el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column label="税率" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.laborItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.laborItem_taxRate"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="中标裸税单价" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.laborItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.laborItem_bidPrice"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="数量" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.laborItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.laborItem_unitCount"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="备注" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.laborItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.laborItem_remark"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="laborItem_unitSumPrice" label="合价"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="laborItem_bidSumPrice" label="中标裸税合价"
                                             :show-overflow-tooltip="true"></el-table-column>
                        </el-table-column>
                        <el-table-column label="材料"
                                         :show-overflow-tooltip="true">
                            <el-table-column prop="materialItem_productName" label="存货名称" width="150px"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="materialItem_productNumber" label="存货编码"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="materialItem_model" label="规格类型"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="materialItem_unit" label="单位"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column label="单价" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.materialItem_productName">
                                    <el-input size="mini" v-model="scope.row.materialItem_unitPrice"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="是否正式单价" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.materialItem_productName">
                                    <el-checkbox v-model="scope.row.materialItem_unitPriceTypeBool"
                                                 :checked="scope.row.materialItem_unitPriceTypeBool"
                                                 >正式单价</el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column label="税率" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.materialItem_productName">
                                    <el-input size="mini" v-model="scope.row.materialItem_taxRate"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="中标裸税单价" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.materialItem_productName">
                                    <el-input size="mini" v-model="scope.row.materialItem_bidPrice"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="数量" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.materialItem_productName">
                                    <el-input size="mini" v-model="scope.row.materialItem_unitCount"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="备注" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.materialItem_productName">
                                    <el-input size="mini" v-model="scope.row.materialItem_remark"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="materialItem_unitSumPrice" label="合价"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="materialItem_bidSumPrice" label="中标裸税合价"
                                             :show-overflow-tooltip="true"></el-table-column>
                        </el-table-column>
                        <el-table-column label="机械"
                                         :show-overflow-tooltip="true">
                            <el-table-column prop="machineItem_subCategoryName" label="细目名称" width="150px"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="machineItem_subCategoryNo" label="细目号"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="machineItem_unit" label="单位"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column label="单价" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.machineItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.machineItem_unitPrice"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="是否正式单价" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.machineItem_subCategoryName">
                                    <el-checkbox v-model="scope.row.machineItem_unitPriceTypeBool"
                                                 :checked="scope.row.machineItem_unitPriceTypeBool"
                                                >正式单价</el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column label="税率" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.machineItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.machineItem_taxRate"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="中标裸税单价" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.machineItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.machineItem_bidPrice"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="数量" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.machineItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.machineItem_unitCount"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="备注" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.machineItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.machineItem_remark"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="machineItem_unitSumPrice" label="合价"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="machineItem_bidSumPrice" label="中标裸税合价"
                                             :show-overflow-tooltip="true"></el-table-column>
                        </el-table-column>
                        <el-table-column label="其他"
                                         :show-overflow-tooltip="true">
                            <el-table-column prop="otherItem_subCategoryName" label="细目名称" width="150px"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="otherItem_subCategoryNo" label="细目号"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="otherItem_unit" label="单位"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column label="单价" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.otherItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.otherItem_unitPrice"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="是否正式单价" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.otherItem_subCategoryName">
                                    <el-checkbox v-model="scope.row.otherItem_unitPriceTypeBool"
                                                 :checked="scope.row.otherItem_unitPriceTypeBool"
                                    >正式单价</el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column label="税率" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.otherItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.otherItem_taxRate"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="中标裸税单价" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.otherItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.otherItem_bidPrice"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="数量" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.otherItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.otherItem_unitCount"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="备注" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.otherItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.otherItem_remark"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="otherItem_unitSumPrice" label="合价"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="otherItem_bidSumPrice" label="中标裸税合价"
                                             :show-overflow-tooltip="true"></el-table-column>
                        </el-table-column>
                        <el-table-column prop="deptName" label="合计"
                                         :show-overflow-tooltip="true">
                            <el-table-column prop="unit_Price" label="单价"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="total_Price" label="合计"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="bidSum_Price" label="中标裸税合价"
                                             :show-overflow-tooltip="true"></el-table-column>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="实际支出"
                                     :show-overflow-tooltip="true">
                        <el-table-column prop="partyBName" label="合作单位"
                                         :show-overflow-tooltip="true"></el-table-column>
                        <el-table-column prop="scope.deptName" label="劳务"
                                         :show-overflow-tooltip="true">
                            <el-table-column prop="nowLaborItem_subCategoryName" label="细目名称" width="150px"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="nowLaborItem_subCategoryNo" label="细目号"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="nowLaborItem_unit" label="单位"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column label="单价" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.nowLaborItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.nowLaborItem_unitPrice"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="是否正式单价" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.nowLaborItem_subCategoryName">
                                    <el-checkbox v-model="scope.row.nowLaborItem_unitPriceTypeBool"
                                                 :checked="scope.row.nowLaborItem_unitPriceTypeBool"
                                                 >正式单价</el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column label="税率" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.nowLaborItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.nowLaborItem_taxRate"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="中标裸税单价" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.nowLaborItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.nowLaborItem_bidPrice"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="数量" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.nowLaborItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.nowLaborItem_unitCount"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="备注" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.nowLaborItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.nowLaborItem_remark"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="nowLaborItem_unitSumPrice" label="合价"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="nowLaborItem_bidSumPrice" label="中标裸税合价"
                                             :show-overflow-tooltip="true"></el-table-column>
                        </el-table-column>
                        <el-table-column label="材料"
                                         :show-overflow-tooltip="true">
                            <el-table-column prop="nowMaterialItem_productName" label="存货名称" width="150px"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="nowMaterialItem_productNumber" label="存货编码"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="nowMaterialItem_model" label="规格类型"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="nowMaterialItem_unit" label="单位"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column label="单价" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.nowMaterialItem_productName">
                                    <el-input size="mini" v-model="scope.row.nowMaterialItem_unitPrice"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="是否正式单价" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.nowMaterialItem_productName">
                                    <el-checkbox v-model="scope.row.nowMaterialItem_unitPriceTypeBool"
                                                 :checked="scope.row.nowMaterialItem_unitPriceTypeBool"
                                                 >正式单价</el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column label="税率" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.nowMaterialItem_productName">
                                    <el-input size="mini" v-model="scope.row.nowMaterialItem_taxRate"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="中标裸税单价" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.nowMaterialItem_productName">
                                    <el-input size="mini" v-model="scope.row.nowMaterialItem_bidPrice"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="数量" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.nowMaterialItem_productName">
                                    <el-input size="mini" v-model="scope.row.nowMaterialItem_unitCount"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="备注" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.nowMaterialItem_productName">
                                    <el-input size="mini" v-model="scope.row.nowMaterialItem_remark"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="nowMaterialItem_unitSumPrice" label="合价"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="nowMaterialItem_bidSumPrice" label="中标裸税合价"
                                             :show-overflow-tooltip="true"></el-table-column>
                        </el-table-column>
                        <el-table-column label="机械"
                                         :show-overflow-tooltip="true">
                            <el-table-column prop="nowMachineItem_subCategoryName" label="细目名称" width="150px"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="nowMachineItem_subCategoryNo" label="细目号"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="nowMachineItem_unit" label="单位"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column label="单价" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.nowMachineItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.nowMachineItem_unitPrice"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="是否正式单价" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.nowMachineItem_subCategoryName">
                                    <el-checkbox v-model="scope.row.nowMachineItem_unitPriceTypeBool"
                                                 :checked="scope.row.nowMachineItem_unitPriceTypeBool"
                                                 >正式单价</el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column label="税率" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.nowMachineItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.nowMachineItem_taxRate"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="中标裸税单价" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.nowMachineItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.nowMachineItem_bidPrice"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="数量" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.nowMachineItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.nowMachineItem_unitCount"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="备注" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.nowMachineItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.nowMachineItem_remark"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="nowMachineItem_unitSumPrice" label="合价"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="nowMachineItem_bidSumPrice" label="中标裸税合价"
                                             :show-overflow-tooltip="true"></el-table-column>
                        </el-table-column>
                        <el-table-column label="其他"
                                         :show-overflow-tooltip="true">
                            <el-table-column prop="nowOtherItem_subCategoryName" label="细目名称" width="150px"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="nowOtherItem_subCategoryNo" label="细目号"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="nowOtherItem_unit" label="单位"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column label="单价" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.nowOtherItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.nowOtherItem_unitPrice"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="是否正式单价" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.nowOtherItem_subCategoryName">
                                    <el-checkbox v-model="scope.row.nowOtherItem_unitPriceTypeBool"
                                                 :checked="scope.row.nowOtherItem_unitPriceTypeBool"
                                                 >正式单价</el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column label="税率" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.nowOtherItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.nowOtherItem_taxRate"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="中标裸税单价" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.nowOtherItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.nowOtherItem_bidPrice"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="数量" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.nowOtherItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.nowOtherItem_unitCount"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="备注" width="150px"
                                             :show-overflow-tooltip="true">
                                <template slot-scope="scope" v-if="scope.row.nowOtherItem_subCategoryName">
                                    <el-input size="mini" v-model="scope.row.nowOtherItem_remark"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="nowOtherItem_unitSumPrice" label="合价"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="nowOtherItem_bidSumPrice" label="中标裸税合价"
                                             :show-overflow-tooltip="true"></el-table-column>
                        </el-table-column>
                        <el-table-column prop="deptName" label="合计"
                                         :show-overflow-tooltip="true">
                            <el-table-column prop="party_unitPrice" label="单价"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="party_unitSumPrice" label="合计"
                                             :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="party_bidSumPrice" label="中标裸税合价"
                                             :show-overflow-tooltip="true"></el-table-column>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column prop="approveStatusShow" label="审核状态"
                                     :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column label="操作" fixed="right" width="250px">
                        <template slot-scope="scope">
                            <el-button @click="handleApproveClick(scope.row)" type="text" size="small">审核</el-button>
                            <el-button @click="handleInfoDetailsClick(scope.row)" type="text" size="small">详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-main>
            <el-footer>
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="dataForm.pageIndex"
                        :page-sizes="[10, 20, 30, 50, 100]"
                        :page-size="dataForm.pageSize"
                        layout="total, prev, pager, next, sizes, jumper"
                        :total="total"
                ></el-pagination>
            </el-footer>
        </el-container>
        <!-- 审批弹框 -->
        <el-dialog
                title="细目审批"
                :visible.sync="approvedialogVisible"
                width="30%"
                :before-close="handleClose"
                :close-on-click-modal="false"
        >
            <el-form :model="Approveform" label-width="70px">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="审批意见">
                            <el-input
                                    type="textarea"
                                    :rows="4"
                                    placeholder="请输入内容"
                                    v-model="Approveform.opinion"
                                    maxlength="266"
                                    size="medium"
                                    style="width: 100%;min-width: 266px"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmsubContract(3)">审批通过</el-button>
        <el-button type="primary" @click="confirmsubContract(4)">驳 回</el-button>
      </span>
        </el-dialog>
    </div>
</template>

<script>
    import {inTheSpanMethod, getJBXXTableData} from '../spanMethod';
    import {
        getDeptListService,
        getProjectListService,
    } from '@/services/invoiceServices'
    import {
        getAuditUserListService,
        queryMiddleAuditListService,
        queryCurrentApproveProcessService,
        submitApproveProcessService, exportMiddleService,
    } from "../../../services/engineering";
    import {exportExcelService2} from "../../../services/allContractServices";
    export default {
        name: "examine",
        data(){
            return {
                dataForm:{
                    deptId:'',
                    projectId:'',
                    pageIndex: 1,
                    pageSize: 10,
                },
                total:0,

                engineerList:[], //数据列表
                deptList:[], //项目部列表
                projectList:[], //项目列表
                userList:[], // 审批人

                approvedialogVisible: false,
                //审批对话框form
                Approveform: {
                    approveCode: "",
                    projectName: "",
                    itemId: "", //项目经理id
                    approveUserId: "", //审批人id
                    deptId: "", //部门id
                    opinion: "" //审批意见
                },

                btnAuthorize: {
                    export: { key: "export", btnEnable: false }
                },
            }
        },
        methods: {
            onActive(menuCode) {
                this.$getRoleBtns(menuCode, this.btnAuthorize);
                this.getDeptList();
                this.getAuditUserList();
            },
            /**
             *  获取项目部列表
             * */
            getDeptList(){
                getDeptListService().then( res => {
                    if(res.code == 10000000){
                        this.deptList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /**
             * 查询项目列表
             * */
            getProjectList(){
                this.dataForm.projectId = '';
                let paramsData = {
                    deptId: this.dataForm.deptId
                }
                getProjectListService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.projectList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /**
             * 查询项目列表
             * */
            getAuditUserList(){
                let paramsData = {
                    type: 'PROJECT_MIDDLE'
                }
                getAuditUserListService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.userList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            //查询
            query(){
                if(!this.dataForm.projectId){
                    this.$message.error('请选择项目名称');
                    return
                }
                let paramsData = {
                   ...this.dataForm
                }
                queryMiddleAuditListService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.engineerList =  inTheSpanMethod(res.data)
                        this.$forceUpdate();
                        this.total =res.total
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            //获取当前审批流
            handleApproveClick(row){
                let paramsData = {
                    id : row.id,
                    type: "PROJECT_MIDDLE",
                }
                queryCurrentApproveProcessService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.approvedialogVisible = true;
                        this.Approveform = { ...res.data };
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            //提交审批流
            confirmsubContract(val){
                let param = this.Approveform;
                param.status = val; //3：通过 4：驳回
                param.type = 'PROJECT_MIDDLE'; // 状态 事中标识
                if (null == param.opinion || param.opinion == "") {
                    this.$alert("请填写审批备注", "提示", {
                        confirmButtonText: "确定"
                    });
                    return;
                }
                this.$confirm(val == 3?"确认审批该细目吗？":"确认驳回该细目吗？", "提示", {
                    confirmButtonText: "确认"
                }).then(() => {
                    submitApproveProcessService(param).then(res => {
                        if (res.code == "10000000") {
                            this.$alert(val == 3?"审批成功":"驳回成功", "提示", {
                                confirmButtonText: "确定"
                            });
                            this.query();
                            this.approvedialogVisible = false;
                        } else if (res.code > 20000000) {
                            this.$alert(res.msg, "提示", {
                                confirmButtonText: "确定"
                            });
                        } else {
                            this.$message.error("系统异常");
                        }
                    })
                        .catch(error => {
                            this.$message.error("系统异常");
                        });
                });
            },
            //审批关闭
            handleClose(done) {
                this.$confirm("确认关闭？")
                    .then(_ => {
                        done();
                    })
                    .catch(_ => {});
            },
            //查看详情
            handleInfoDetailsClick(row){
                this.bus.$emit("navMenuChange", {
                    routeId: "inTheInfoDetails",
                    routeParam: {
                        id: row.id,
                        index: 2,
                    }
                });
            },
            /***
             * 导出
             */
            exportBtn(){
                if(!this.dataForm.projectId){
                    this.$message.error('请先选择项目名称后再导出！');
                    return
                }
                let params = {
                    ...this.dataForm,
                }
                exportMiddleService(params).then( res => {
                    if(res.code == 10000000){
                        exportExcelService2(res.data).then(res1 => {
                            this.$message.success('导出成功');
                        });
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            reset(){
                this.dataForm = {
                    deptId:'',
                    projectId:'',
                    pageIndex: 1,
                    pageSize: 10,
                }
                this.total = 0;
                this.engineerList = [];
                this.projectList = [];
            },
            // 分页改变事件
            handleCurrentChange(page) {
                this.dataForm.pageIndex = page;
                this.query();
            },
            // 分页显示数量改变事件
            handleSizeChange(rows) {
                this.dataForm.pageIndex = 1;
                this.dataForm.pageSize = rows;
                this.query();
            },
            //合并表格条件
            spanArrayMethod({row,column,rowIndex,columnIndex}) {
                if (columnIndex <= 14 || columnIndex >= 112 || (columnIndex >= 60 && columnIndex <= 62)) {
                    const _row = (getJBXXTableData(this.engineerList).one)[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    };
                }
                if (columnIndex === 63|| columnIndex === 109 || columnIndex === 110 || columnIndex === 111 ) {
                    const _row = (getJBXXTableData(this.engineerList).two)[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    };
                }
            },

        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/commonLayout.scss";
    .engineering {
        height: 100%;
        background-color: white;
        display: flex;
        flex-direction: column;
    }
    .btnRight {
        display: flex;
        justify-content: flex-end;
    }
    /deep/.el-table{
        th>.cell{
            text-align: center;
        }
        .cell.el-tooltip{
            display: flex;
            justify-content: center;
        }
    }
    /deep/.el-icon-close:before {
        color: #fff!important;
        font-size: 16px;
    }
</style>
